var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavoriteActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17.0931C8.61712 17.094 8.2335 16.9741 7.90843 16.7345C5.47387 14.94 3.68879 13.0226 2.5 11.5C1.14013 9.75824 0 7.87923 0 5.96653C0 3.22354 2.23853 1 5 1C6.0891 1 7.09714 1.34589 7.91851 1.93307C8.33039 2.22752 8.69532 2.58264 9 2.98525C9.30468 2.58264 9.66961 2.22752 10.0815 1.93307C10.9029 1.34589 11.9109 1 13 1C15.7615 1 18 3.22354 18 5.96653C18 7.87923 16.8599 9.75824 15.5 11.5C14.3112 13.0226 12.5261 14.94 10.0916 16.7345C9.7665 16.9741 9.38288 17.094 9 17.0931Z",
    fill: "#F44519"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavoriteActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favoriteActive.b0c5c7cda335c41d2c9cf0e66a515e88.svg";